/* eslint-disable */

class Replacer {
    /**
     * @static
     * @param {string} value
     * @param {number} nb
     * @param {string} char
     * @param {string | null} replacer
     * @param {number} thresholds
     *
     * @return {string}
     */
    static plural({ value, nb, char, replacer, thresholds }) {
        try {
            const errorWording = `Missing parameters or bad type. value: ${value}, nb: ${nb}`;
            if(!value || typeof value !== 'string' || (!nb && nb != 0)) throw new Error(errorWording);

            nb = Number.parseInt(nb);
            thresholds = Number.parseInt(thresholds);

            if(replacer && (nb > thresholds)) value = replacer;
            else if((nb > thresholds) && char) value = `${value}${char}`;
        } catch (err) {
            console.error(err);
        } finally {
            return value;
        }
    }
}

String.prototype.plural = function({ nb, char = 's', replacer = null, thresholds = 1 }) {
    const value = this.valueOf();
    return Replacer.plural({ value, nb, char, replacer, thresholds });
}

class LocalAndSessionStorageManager {

    /** @static @private */
    static #basicTypes = ['localStorage', 'sessionStorage'];
    static #basicWordingError = `Missing parameters or bad types.`;
    static #buildError = mess => this.#basicWordingError.concat(` ${mess}`);
    static #testingType = type => this.#basicTypes.includes(type);

    /**
    * @static
    * @param { {key: string, value: *, type: ?string} }
    */
    static addItem({ key, value, type = 'localStorage' }) {
        try {
            const errorWording = this.#buildError(`type: ${type}, value: ${value}, key: ${key}`);
            if(!key || typeof key !== 'string' || !value || !this.#testingType(type)) throw new Error(errorWording);

            const jsonValue = JSON.stringify(value);
            window[type].setItem(key, jsonValue);
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * @static
     * @param { { arrayOfArrayKeyValue: [][key: string, value: *], type: ?string } }
     */
    static addItems({ arrayOfArrayKeyValue, type = 'localStorage' }) {
        try {
            const errorWording = this.#buildError(`type: ${type}, arrayOfArrayKeyValue: ${arrayOfArrayKeyValue}`);
            if(!arrayOfArrayKeyValue || !Array.isArray(arrayOfArrayKeyValue) || !this.#testingType(type)) throw new Error(errorWording);

            for (const [ key, value ] of arrayOfArrayKeyValue) {
                this.addItem({ key, value, type });
            }
        } catch (error) {
            console.error(error);
        }
    }

    /**
    * @static
    * @param { { key: string, type: ?string } }
    * @return { * }
    */
    static getItem({ key, type = 'localStorage' }) {
        try {
            const errorWording = this.#buildError(`type: ${type}, key: ${key}`);
            if(!key || typeof key !== 'string' || !this.#testingType(type)) throw new Error(errorWording);

            const jsonValue = window[type].getItem(key);
            const value =  JSON.parse(jsonValue);
            return value;
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * @static
     * @param { { key: string, type = ?string } }
     */
    static removeItem({ key, type = 'localStorage' }) {
        try {
            const errorWording = this.#buildError(`key: ${key}, type: ${type}`);
            if(!key || typeof key !== 'string' || !this.#testingType(type)) throw new Error(errorWording);

            window[type].removeItem(key);
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * @static
     * @param { { arrayOfKeys: string[], type: ?string } }
     */
    static removeItems({ arrayOfKeys, type = 'localStorage' }) {
        try {
            const errorWording = this.#buildError(`arrayOfKeys: ${arrayOfKeys}, type: ${type}`);
            if(!arrayOfKeys || !Array.isArray(arrayOfKeys) || !this.#testingType(type)) throw new Error(errorWording);

            for(const key of arrayOfKeys) {
                this.removeItem({ key, type });
            }
        } catch (error) {
            console.error(error);
        }
    }
}

class Memory {
    /** @private {number} */
    #memo;

    constructor() {
        this.#memo = 0;
    }

    /**
     * @param {boolean} reinit
     * @return {instanceOf Memory}
     */
    changeState(reinit) {
        if(!reinit) this.#memo = 1;
        else this.#memo = 0;
        return this;
    }
    /**
     * @param {() => boolean} func (si le return est trusthy, 1 sera le nouvel état de #memo)
     * @return {instanceOf Memory}
     */
    changeStateWithPayload(func) {
        try {
            if(!func) {
                this.#memo = 1;
                return this;
            }
            this.#memo = func() ? 1 : 0;
            return this;
        } catch (err) {
            console.error(err);
        }
    }

    /**
     * @return {number} memo
     */
    get memoState() {
        return this.#memo;
    }
}